<ul class="timeline mt-2">
    <li *ngFor="let item of log" class="mb-3">
        <ng-container
            *ngIf="journeyFilter.indexOf(item.event)!==-1 || ((item.event == 'buttonPressed' || item.event == 'downloadPressed') &&  journeyFilter.indexOf('componentPressed')!==-1)">
            <ng-container [ngSwitch]="item.event">
                <span *ngSwitchDefault>
                    <span class="timeline-icon"><i class="bx bx-list-plus"></i>
                    </span>
                    <span class="timeline-title">{{ item.event }}</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>
                <span *ngSwitchCase="'makeChoice'">
                    <span class="timeline-icon"><i class="bx bx-list-plus"></i>
                    </span>
                    <span class="timeline-title">Made choice "{{ getChoice(item.data.id, scenario)?.title }}" on
                        "{{ getStep(item.data.stepId, scenario)?.title }}"</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'goToStep'">
                    <span class="timeline-icon"><i class="bx bx-sitemap"></i> </span>
                    <span class="timeline-title">Go To step "{{ getStep(item.data.id, scenario)?.title }}"</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'pickItems'">
                    <span class="timeline-icon"><i class="bx bx-task"></i> </span>
                    <span class="timeline-title">Picked items on pick task</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>

                    <div class="inventory-items mt-1">
                        <div *ngFor="let item of item.data.items" class="inventory-item item-picked"
                            style="min-height:50px;">
                            <img src="{{ item.image }}" alt="{{ item.description }}" *ngIf="item.image" />
                            <div class="item-name">{{ item.name }}</div>
                        </div>
                    </div>
                </span>

                <span *ngSwitchCase="'addToInventory'">
                    <span class="timeline-icon"><i class="bx bx-briefcase-alt-2"></i> </span>
                    <span class="timeline-title">Items added to inventory</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>

                    <div class="inventory-items mt-1">
                        <div *ngFor="let item of item.data.items" class="inventory-item item-picked"
                            style="min-height:50px;">
                            <img src="{{ item.image }}" alt="{{ item.description }}" *ngIf="item.image" />
                            <div class="item-name">{{ item.name }}</div>
                        </div>
                    </div>
                </span>

                <span *ngSwitchCase="'removeFromInventory'">
                    <span class="timeline-icon"><i class="bx bx-briefcase-alt-2"></i> </span>
                    <span class="timeline-title">Items removed from inventory</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>

                    <div class="inventory-items mt-1">
                        <div *ngFor="let item of item.data.items" class="inventory-item item-picked"
                            style="min-height:50px;">
                            <img src="{{ item.image }}" alt="{{ item.description }}" *ngIf="item.image" />
                            <div class="item-name">{{ item.name }}</div>
                        </div>
                    </div>
                </span>

                <span *ngSwitchCase="'chatStem'">
                    <span class="timeline-icon"><i class="bx bx-comment"></i> </span>
                    <span class="timeline-title">Asked:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>

                    <blockquote>{{ item.data.q }}</blockquote>
                </span>

                <span *ngSwitchCase="'buttonPressed'">
                    <span class="timeline-icon"><i class="bx bx-power-off"></i>
                    </span>
                    <span class="timeline-title">Button '{{ item.data.text }}' Pressed:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'componentPressed'">
                    <span class="timeline-icon"><i class="bx bxs-hand-up"></i> </span>
                    <span class="timeline-title">Component '{{ item.data.name }}' Pressed:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'componentHovered'">
                    <span class="timeline-icon"><i class="bx bxs-hand-up"></i> </span>
                    <span class="timeline-title">Component '{{ item.data.name }}' Hovered:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>


                <span *ngSwitchCase="'componentHoverOut'">
                    <span class="timeline-icon"><i class="bx bxs-hand-right"></i> </span>
                    <span class="timeline-title">Component '{{ item.data.name }}' Hovered out:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>


                <span *ngSwitchCase="'componentDropped'">
                    <span class="timeline-icon"><i class="bx bxs-hand-down"></i> </span>
                    <span class="timeline-title">Component '{{ item.data.name }}' Dropped:</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'downloadPressed'">
                    <span class="timeline-icon"><i class="bx bx-power-off"></i>
                    </span>
                    <span class="timeline-title">Downloaded {{ item.data.src }}</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'hotspotPressed'">
                    <span class="timeline-icon"><i class="bx bx-sun"></i> </span>
                    <span class="timeline-title">Pressed hotspot "{{ item.data.hotspot?.title }}"</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'quizAnswered'">
                    <span class="timeline-icon"><i class="bx bx-check-square"></i>
                    </span>
                    <span class="timeline-title">Quiz Question Answered</span>
                    <div>
                        <div class="list-group-item py-2" [innerHTML]="item.data.question | safeHtml"></div>
                    </div>
                    <div>
                        <ul *ngIf="item.data.answers" class="list-group list-group-sm">
                            <li *ngFor="let answer of item.data.answers" class="list-group-item">
                                <i class="bx bx-check" *ngIf="answer.correct"></i>
                                <i class="bx bx-x" *ngIf="!answer.correct"></i>
                                {{ answer.answer }}
                            </li>
                        </ul>
                    </div>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'formSubmitted'">
                    <span class="timeline-icon"><i class="bx bx-check-square"></i>
                    </span>
                    <span class="timeline-title">Form Submitted</span>
                    <div>
                        <ul class="list-group list-group-horizontal">
                            <li *ngFor="
                      let field of item.data?.formattedData | keyvalue;
                      let fieldIndex = index
                    " class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">{{ field.key }}</div>
                                    <div *ngIf="getTypeOf(field.value) == 'object'">
                                        <!-- it's a likert-->
                                        <ul>
                                            <li *ngFor="let statement of getFieldValue(field.value)">
                                                {{ statement.statement
                                                }}<strong>
                                                    -
                                                    {{statement.optionLabel}}
                                                </strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div *ngIf="getTypeOf(field.value) !== 'object'">
                                        {{ field.value }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'quizCompleted'">
                    <span class="timeline-icon"><i class="bx bx-check-square"></i>
                    </span>
                    <span class="timeline-title">Quiz Completed</span>
                    <div>Score: {{ item.data.score }}</div>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>
                <span *ngSwitchCase="'videoEnd'">
                    <span class="timeline-icon"><i class="bx bx-video"></i> </span>
                    <span class="timeline-title">Video ended "<ng-container *ngIf="item.data?.name">{{
                            item.data?.name
                            }}</ng-container>
                        <ng-container *ngIf="!item.data?.name">{{
                            playerService.getComponent(scenario, item.data?.id)?.name
                            }}</ng-container>"
                    </span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'activityEnded'">
                    <span class="timeline-icon"><i class="bx bx-subdirectory-left"></i>
                    </span>
                    <span class="timeline-title">Ended activity {{ item.data.type }}</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>

                <span *ngSwitchCase="'varSet'">
                    <span class="timeline-icon"><i class="bx bx-code-curly"></i>
                    </span>
                    <span class="timeline-title">Variable "{{item.data.name}}" changed from "{{item.data.old}}" to
                        "{{item.data.new}}"</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>


                <span *ngSwitchCase="'restarted'">
                    <span class="timeline-icon"><i class="bx bx-refresh"></i>
                    </span>
                    <span class="timeline-title">Restarted</span>
                    <span class="timeline-time">{{
                        item.duration * 1000 | date : "mm:ss"
                        }}</span>
                </span>
            </ng-container>

            <!--ng-container *ngIf="enableComments">

                <button class="btn btn-sm btn-link text-dark" tooltip="Add comment" [delay]="500"
                    (click)="onAddComment(item)">
                    <span class="visually-hidden">Add Comment</span><i class="bx bxs-comment-add"></i>
                </button>

                <div class="comments ms-2 border-start-3" *ngIf="item.comments && item.comments.length > 0">
                    <ul class="list-group">
                        <li class="list-group-item relative pe-3"
                            *ngFor="let comment of item.comments; let index = index">
                            <div class="btn-group btn-group-rounded position-absolute end-0 me-2">
                                <button (click)="onEditComment(comment)" class="btn btn-darken btn-sm">
                                    <i class="bx bxs-edit"></i>
                                    <span class="visually-hidden">Edit</span>
                                </button>
                                <button (click)="onDeleteComment(item, index)" class="btn btn-darken btn-sm">
                                    <i class="bx bxs-trash"></i>
                                    <span class="visually-hidden">Delete</span>
                                </button>
                            </div>

                            <p class="pb-1 m-0">{{ comment.comment }}</p>

                            <em>
                                <small>{{ comment.date | timeago }}</small></em>
                        </li>
                    </ul>
                </div>
            </ng-container-->
        </ng-container>
    </li>
</ul>